import type { AppState } from '@/store/app.state';
import { createSelector } from '@reduxjs/toolkit';
import { isDefined } from '@sgme/fp';

export const canModifyAlert = ({ user }: AppState) => user.currentUser?.canExecute ?? false;

export const selectHasSpotRight = ({ user }: AppState) => isDefined(user.navigateAsUser) ? user.navigateAsUser.hasSpotRight : user.currentUser?.hasSpotRight ?? false;

export const selectHasAmericanForwardRight = ({ user }: AppState) =>
  isDefined(user.navigateAsUser) ? user.navigateAsUser.hasAmericanForwardRight : (user.currentUser?.hasAmericanForwardRight ?? false);

export const selectHasForwardRight = ({ user }: AppState) => (isDefined(user.navigateAsUser) ? user.navigateAsUser.hasForwardRight : (user.currentUser?.hasForwardRight ?? false));

export const selectHasCallRight = ({ user }: AppState) => (isDefined(user.navigateAsUser) ? user.navigateAsUser.hasCallRight : (user.currentUser?.hasCallRight ?? false));

export const selectHasSwapRight = ({ user }: AppState) => (isDefined(user.navigateAsUser) ? user.navigateAsUser.hasSwapRight : (user.currentUser?.hasSwapRight ?? false));

export interface ProductsRights {
  hasSpotRight: boolean;
  hasForwardRight: boolean;
  hasAmericanForwardRight: boolean;
  hasCallRight: boolean;
  hasSwapRight: boolean;
}

export const selectProductsRights = createSelector(
  [selectHasSpotRight, selectHasForwardRight, selectHasAmericanForwardRight, selectHasCallRight, selectHasSwapRight],
  (hasSpotRight: boolean, hasForwardRight: boolean, hasAmericanForwardRight: boolean, hasCallRight: boolean, hasSwapRight: boolean): ProductsRights => ({
    hasSpotRight,
    hasForwardRight,
    hasAmericanForwardRight,
    hasCallRight,
    hasSwapRight,
  }),
);

export const selectUser = ({ user }: AppState) => user;

export const selectSelectedCompany = ({ user }: AppState) => user.selectedCompany;

export const selectRfsCurrencies = ({ user }: AppState) => user.selectedCompany!.rfsCurrencies;

export const selectCompanies = ({ user }: AppState) => (user.navigateAsUser ? user.navigateAsUser.companies : (user.currentUser?.companies ?? []));

export const selectCurrentUser = ({ user }: AppState) => user.currentUser;

export const selectUserType = (app: AppState) => app.user.currentUser?.userType;

export const selectCurrentUserEmail = ({ user }: AppState) => user.currentUser?.email;

export const selectNavigateAsUser = ({ user }: AppState) => user.navigateAsUser;

export const selectNavigableAsUsers = ({ user }: AppState) => user.navigableAsUsers;

export const selectMnemo = ({ user }: AppState) => user.selectedCompany?.companyMnemonic;
